import { Location, Route, Routes } from 'react-router-dom';
import NotFound from 'src/components/pages/Error/NotFound';
import Unauthorized from 'src/components/pages/Error/Unauthorized';
import { CertificatesPage } from './components/pages/Certificates/CertificatesPage';
import { CorrectionsPage } from './components/pages/Corrections/CorrectionsPage';
import { CustomersPage } from './components/pages/Customers/CustomersPage';
import { DashboardPage } from './components/pages/Dashboard/DashboardPage';
import { GradesPage } from './components/pages/Grades/GradesPage';
import { CamsizerPage } from './components/pages/Imports/Camsizer/CamsizerPage';
import { EurofinsPage } from './components/pages/Imports/Eurofins/EurofinsPage';
import { GDMSPage } from './components/pages/Imports/GDMS/GDMSPage';
import { NorlabPage } from './components/pages/Imports/Norlab/NorlabPage';
import { InstrumentGroupsPage } from './components/pages/InstrumentGroups/InstrumentGroupsPage';
import { InstrumentsPage } from './components/pages/Instruments/InstrumentsPage';
import { LabelTemplatesPage } from './components/pages/LabelTemplates/LabelTemplatesPage';
import { MethodsPage } from './components/pages/Methods/MethodsPage';
import { MixturePage } from './components/pages/Mixtures/Mixture/MixturePage';
import { MixturesPage } from './components/pages/Mixtures/MixturesPage';
import { MixtureTypePage } from './components/pages/MixtureTypes/MixtureType/MixtureTypePage';
import { MixtureTypesPage } from './components/pages/MixtureTypes/MixtureTypesPage';
import { PackagingsPage } from './components/pages/Packagings/PackagingsPage';
import { PalletsPage } from './components/pages/Pallets/PalletsPage';
import { ParameterGroupsPage } from './components/pages/ParameterGroups/ParameterGroupsPage';
import { ParametersPage } from './components/pages/Parameters/ParametersPage';
import { ParameterSetPage } from './components/pages/ParameterSets/ParameterSet/ParameterSetPage';
import { ParameterSetsPage } from './components/pages/ParameterSets/ParameterSetsPage';
import { PlantsPage } from './components/pages/Plants/PlantsPage';
import { ProductPage } from './components/pages/Products/Product/ProductPage';
import { ProductsPage } from './components/pages/Products/ProductsPage';
import { ProductTypesPage } from './components/pages/ProductTypes/ProductTypesPage';
import { RecipientsPage } from './components/pages/Recipients/RecipientsPage';
import { RunSystemsPage } from './components/pages/RunSystems/RunSystemsPage';
import { SegmentsPage } from './components/pages/Segments/SegmentsPage';
import { SpecificationPage } from './components/pages/Specifications/Specification/SpecificationPage';
import { SpecificationsPage } from './components/pages/Specifications/SpecificationsPage';

export const AppRoutes = ({ location }: { location: Location }) => (
  <Routes location={location}>
    <Route path="/" element={<DashboardPage />} />
    <Route path="/products" element={<ProductsPage />} />
    <Route path="/products/create" element={<ProductPage />} />
    <Route path="/products/:id" element={<ProductPage />} />
    <Route path="/mixtures" element={<MixturesPage />} />
    <Route path="/mixtures/create" element={<MixturePage />} />
    <Route path="/mixtures/:id" element={<MixturePage />} />
    <Route path="/specifications" element={<SpecificationsPage />} />
    <Route path="/specifications/create" element={<SpecificationPage />} />
    <Route path="/specifications/:id" element={<SpecificationPage />} />
    <Route path="/corrections" element={<CorrectionsPage />} />
    <Route path="/grades" element={<GradesPage />} />
    <Route path="/runsystems" element={<RunSystemsPage />} />
    <Route path="/parameters" element={<ParametersPage />} />
    <Route path="/parametergroups" element={<ParameterGroupsPage />} />
    <Route path="/methods" element={<MethodsPage />} />
    <Route path="/instruments" element={<InstrumentsPage />} />
    <Route path="/instrumentgroups" element={<InstrumentGroupsPage />} />
    <Route path="/plants" element={<PlantsPage />} />
    <Route path="/producttypes" element={<ProductTypesPage />} />
    <Route path="/segments" element={<SegmentsPage />} />
    <Route path="/pallets" element={<PalletsPage />} />
    <Route path="/labeltemplates" element={<LabelTemplatesPage />} />
    <Route path="/packagings" element={<PackagingsPage />} />
    <Route path="/customers" element={<CustomersPage />} />
    <Route path="/recipients" element={<RecipientsPage />} />
    <Route path="/mixturetypes" element={<MixtureTypesPage />} />
    <Route path="/mixturetypes/create" element={<MixtureTypePage />} />
    <Route path="/mixturetypes/:id" element={<MixtureTypePage />} />
    <Route path="/parametersets" element={<ParameterSetsPage />} />
    <Route path="/parametersets/create" element={<ParameterSetPage />} />
    <Route path="/certificates" element={<CertificatesPage />} />
    <Route path="/parametersets/:id" element={<ParameterSetPage />} />
    <Route path="/importgdms" element={<GDMSPage />} />
    <Route path="/importcamsizer" element={<CamsizerPage />} />
    <Route path="/importnorlab" element={<NorlabPage />} />
    <Route path="/importeurofins" element={<EurofinsPage />} />
    <Route path="/notfound" element={<NotFound />} />
    <Route path="/unauthorized" element={<Unauthorized />} />
  </Routes>
);
